// extracted by mini-css-extract-plugin
export default {"container":"EditPatientData_container__gB9xF"};